// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainConts .formText{padding:15px 25px 20px 25px!important;text-align:left!important}.todoConts .formText{padding:10px 25px 10px 25px!important;text-align:left!important}.mainConts img{padding:0!important}.contentsCardBodyArea .formDot,.contentsCardBodyArea .formLine{padding:0 10px!important}", ""]);
// Exports
module.exports = exports;
